import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';
import '@/App.css';

import HomePage from '@/pages/HomePage';
import LoginPage from '@/pages/LoginPage';
import Dashboard from '@/pages/Dashboard';
import AdminPage from '@/pages/AdminPage';
import SimulationWizard from '@/pages/SimulationWizard';
import SimulationResults from '@/pages/SimulationResults';
import CompareSimulations from '@/pages/CompareSimulations';
import PropertiesList from '@/pages/PropertiesList';
import PropertyForm from '@/pages/PropertyForm';
import PropertyDetail from '@/pages/PropertyDetail';
import MarketDataPage from '@/pages/MarketDataPage';
import AuthCallback from '@/pages/AuthCallback';
import ProtectedRoute from '@/components/ProtectedRoute';
import ConseillerProPage from '@/pages/ConseillerProPage';
import GoogleAnalytics from '@/components/GoogleAnalytics';

// Blog Pages
import Blog from '@/pages/Blog';
import BlogArticle from '@/pages/BlogArticle';

// SEO Guide Pages
import SimulateurRentabiliteLocative from '@/pages/guides/SimulateurRentabiliteLocative';
import CalculRentabiliteEmprunt from '@/pages/guides/CalculRentabiliteEmprunt';
import RentabiliteAirbnbVsLocation from '@/pages/guides/RentabiliteAirbnbVsLocation';
import CashFlowImmobilier from '@/pages/guides/CashFlowImmobilier';
import ConvaincreBanquier from '@/pages/ConvaincreBanquier';

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id (Google OAuth callback)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute>
          <AdminPage />
        </ProtectedRoute>
      } />
      <Route path="/properties" element={
        <ProtectedRoute>
          <PropertiesList />
        </ProtectedRoute>
      } />
      <Route path="/properties/new" element={
        <ProtectedRoute>
          <PropertyForm />
        </ProtectedRoute>
      } />
      <Route path="/properties/:id" element={
        <ProtectedRoute>
          <PropertyDetail />
        </ProtectedRoute>
      } />
      <Route path="/market-data" element={
        <ProtectedRoute>
          <MarketDataPage />
        </ProtectedRoute>
      } />
      <Route path="/simulation/new" element={
        <ProtectedRoute>
          <SimulationWizard />
        </ProtectedRoute>
      } />
      <Route path="/simulation/:id" element={
        <ProtectedRoute>
          <SimulationResults />
        </ProtectedRoute>
      } />
      <Route path="/compare" element={
        <ProtectedRoute>
          <CompareSimulations />
        </ProtectedRoute>
      } />
      <Route path="/conseiller-pro" element={
        <ProtectedRoute>
          <ConseillerProPage />
        </ProtectedRoute>
      } />
      
      {/* Blog Routes */}
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogArticle />} />
      
      {/* SEO Guide Pages - Public */}
      <Route path="/guides/simulateur-rentabilite-locative" element={<SimulateurRentabiliteLocative />} />
      <Route path="/guides/calcul-rentabilite-locative-emprunt" element={<CalculRentabiliteEmprunt />} />
      <Route path="/guides/rentabilite-airbnb-vs-location" element={<RentabiliteAirbnbVsLocation />} />
      <Route path="/guides/cash-flow-immobilier" element={<CashFlowImmobilier />} />
      <Route path="/convaincre-banquier" element={<ConvaincreBanquier />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <Toaster
          position="top-right"
          toastOptions={{
            style: {
              background: 'rgba(0, 0, 0, 0.8)',
              backdropFilter: 'blur(12px)',
              border: '1px solid rgba(0, 240, 255, 0.3)',
              color: '#ffffff',
            },
          }}
        />
        <GoogleAnalytics />
      </BrowserRouter>
    </div>
  );
}

export default App;
